import React from 'react';

import { ButtonStyled, ButtonDivStyled } from './styles';

const Button = props => {
  const { children, variant, disabled = false, component = 'button', onClick = () => {} } = props;

  if (component === 'div') {
    return (
      <ButtonDivStyled $variant={variant} disabled={disabled} onClick={onClick}>
        {children}
      </ButtonDivStyled>
    );
  }
  return (
    <ButtonStyled $variant={variant} disabled={disabled} onClick={onClick}>
      {children}
    </ButtonStyled>
  );
};

export default Button;
